import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom';
import { orderStatuses, orderTypes } from '../../names';

export const AverageCheque = ({orders}) => {

    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        setIsReady(true);
    });

    if (!isReady) {
        return null;
    }

    const turnover = orders.reduce((total, order) => total + (order.clearAmount || 0), 0);
    const ordersCount = orders.filter(order => 
        order.details.finished &&
        order.orderStatus.name !== orderStatuses.CANCEL &&
        order.orderType.name !== orderTypes.WARRANTY
    ).length;
    const averageCheque = ordersCount ? Math.round(turnover/ordersCount) || 0 : 0;

    return createPortal(
        <div>
            Средний: <b>{averageCheque.toLocaleString('fr-FR')}</b>
        </div>,
        document.getElementById('average-cheque-root'),
    );
}
